import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
    if (_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

/* tslint:disable:member-ordering */
// TODO: remove line below after fixing tests

/* istanbul ignore file */
import { StateType as SessionManagerStateType } from '@central-products/interface-session-manager';
import { ObSessionServiceInterface, ObSessionStateType } from '@central-products/interface-obsession-service';
import { ObSessionServiceErrors } from './enums';

var ObSessionService = /*#__PURE__*/function (_ObSessionServiceInte) {
  _inherits(ObSessionService, _ObSessionServiceInte);

  var _super = _createSuper2(ObSessionService);

  function ObSessionService(config, // @ts-ignore
  dependencies) {
    var _this;

    _classCallCheck(this, ObSessionService);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "shouldFollowLogout", false);

    _defineProperty(_assertThisInitialized(_this), "obSessionServiceUrl", void 0);

    _defineProperty(_assertThisInitialized(_this), "casUrl", void 0);

    _defineProperty(_assertThisInitialized(_this), "sessionManager", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", ObSessionStateType.SESSION_UNKNOWN);

    _defineProperty(_assertThisInitialized(_this), "onStateChangedCallback", void 0);

    _defineProperty(_assertThisInitialized(_this), "abortController", new AbortController());

    _defineProperty(_assertThisInitialized(_this), "loginAwaiters", []);

    _defineProperty(_assertThisInitialized(_this), "processSessionManagerState", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var state, _yield$_this$sessionM, sessionId;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = _ref.state;

                if (!(state === SessionManagerStateType.LOGGED_IN)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 4;
                return _this.sessionManager.getSessionIdentifier();

              case 4:
                _yield$_this$sessionM = _context.sent;
                sessionId = _yield$_this$sessionM.sessionId;

                _this.login(sessionId);

                _context.next = 10;
                break;

              case 9:
                if (state === SessionManagerStateType.NOT_LOGGED_IN) {
                  _this.logout();
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setState", function (state) {
      if (_this.state === state) {
        return;
      }

      _this.state = state;

      if (state === ObSessionStateType.SESSION_EXISTS) {
        _this.resolveLoginAwaiters();
      }

      if (_this.onStateChangedCallback) {
        _this.onStateChangedCallback({
          state: state
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getSessionSyncIdentifier", function () {
      var _window$localStorage$, _window$localStorage, _window$localStorage$2;

      return (_window$localStorage$ = (_window$localStorage = window.localStorage) === null || _window$localStorage === void 0 ? void 0 : (_window$localStorage$2 = _window$localStorage.getItem) === null || _window$localStorage$2 === void 0 ? void 0 : _window$localStorage$2.call(_window$localStorage, ObSessionService.SESSION_SYNC_IDENTIFIER)) !== null && _window$localStorage$ !== void 0 ? _window$localStorage$ : null;
    });

    _defineProperty(_assertThisInitialized(_this), "hasSessionSyncIdentifier", function () {
      var _window$localStorage2, _window$localStorage3;

      return ((_window$localStorage2 = window.localStorage) === null || _window$localStorage2 === void 0 ? void 0 : (_window$localStorage3 = _window$localStorage2.getItem) === null || _window$localStorage3 === void 0 ? void 0 : _window$localStorage3.call(_window$localStorage2, ObSessionService.SESSION_SYNC_IDENTIFIER)) != null;
    });

    _defineProperty(_assertThisInitialized(_this), "setSessionSyncIdentifier", function (sessionId) {
      var _window$localStorage4, _window$localStorage5;

      (_window$localStorage4 = window.localStorage) === null || _window$localStorage4 === void 0 ? void 0 : (_window$localStorage5 = _window$localStorage4.setItem) === null || _window$localStorage5 === void 0 ? void 0 : _window$localStorage5.call(_window$localStorage4, ObSessionService.SESSION_SYNC_IDENTIFIER, sessionId);
    });

    _defineProperty(_assertThisInitialized(_this), "clearSessionSyncIdentifier", function () {
      var _window$localStorage6, _window$localStorage7;

      (_window$localStorage6 = window.localStorage) === null || _window$localStorage6 === void 0 ? void 0 : (_window$localStorage7 = _window$localStorage6.removeItem) === null || _window$localStorage7 === void 0 ? void 0 : _window$localStorage7.call(_window$localStorage6, ObSessionService.SESSION_SYNC_IDENTIFIER);
    });

    if (!config.obSessionServiceUrl) {
      throw new Error(ObSessionServiceErrors.MISSING_SERVICE_URL);
    }

    if (!config.casUrl) {
      throw new Error(ObSessionServiceErrors.MISSING_CAS_URL);
    }

    if (typeof config.shouldFollowLogout !== 'undefined') {
      _this.shouldFollowLogout = config.shouldFollowLogout;
    }

    var obSessionServiceUrl = config.obSessionServiceUrl,
        casUrl = config.casUrl;
    _this.obSessionServiceUrl = obSessionServiceUrl.endsWith('/') ? obSessionServiceUrl : "".concat(obSessionServiceUrl, "/");
    _this.casUrl = casUrl.endsWith('/') ? casUrl : "".concat(casUrl, "/");
    _this.sessionManager = dependencies['session-manager'];
    return _this;
  }

  _createClass(ObSessionService, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var sessionManagerState;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.sessionManager.getState();

              case 2:
                sessionManagerState = _context2.sent;
                this.sessionManager.onStateChanged(this.processSessionManagerState);
                this.processSessionManagerState(sessionManagerState);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "getState",
    value: function () {
      var _getState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", {
                  state: this.state
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getState() {
        return _getState.apply(this, arguments);
      }

      return getState;
    }()
  }, {
    key: "onStateChanged",
    value: function onStateChanged(callback) {
      this.onStateChangedCallback = callback;
    }
  }, {
    key: "awaitLoggedIn",
    value: function awaitLoggedIn() {
      var _this2 = this;

      if (this.state === ObSessionStateType.SESSION_EXISTS) {
        return _Promise.resolve({});
      }

      return new _Promise(function (resolve) {
        return _this2.loginAwaiters.push(resolve);
      });
    }
  }, {
    key: "resolveLoginAwaiters",
    value: function resolveLoginAwaiters() {
      var waiter; // tslint:disable-next-line no-conditional-assignment

      while (waiter = this.loginAwaiters.pop()) {
        waiter({});
      }
    }
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(sessionId) {
        var previousState;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.state !== ObSessionStateType.NO_SESSION && this.state !== ObSessionStateType.SESSION_UNKNOWN)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                _context4.next = 4;
                return this.hasValidSession(sessionId);

              case 4:
                if (!_context4.sent) {
                  _context4.next = 8;
                  break;
                }

                this.setSessionSyncIdentifier(sessionId);
                this.setState(ObSessionStateType.SESSION_EXISTS);
                return _context4.abrupt("return");

              case 8:
                previousState = this.state;
                this.setState(ObSessionStateType.SESSION_REQUESTED);
                _context4.prev = 10;
                _context4.next = 13;
                return this.initSession();

              case 13:
                this.setSessionSyncIdentifier(sessionId);
                this.setState(ObSessionStateType.SESSION_EXISTS);
                _context4.next = 21;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](10);
                this.setState(previousState);
                throw new Error(ObSessionServiceErrors.UNABLE_TO_INITIALIZE);

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[10, 17]]);
      }));

      function login(_x4) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var previousState;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.state === ObSessionStateType.NO_SESSION)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                if (!(this.state === ObSessionStateType.SESSION_UNKNOWN)) {
                  _context5.next = 6;
                  break;
                }

                this.clearSessionSyncIdentifier();
                this.setState(ObSessionStateType.NO_SESSION);
                return _context5.abrupt("return");

              case 6:
                if (this.state === ObSessionStateType.SESSION_REQUESTED) {
                  this.abortController.abort();
                }

                previousState = this.state;
                _context5.prev = 8;
                _context5.next = 11;
                return this.destroySession();

              case 11:
                this.clearSessionSyncIdentifier();
                this.setState(ObSessionStateType.NO_SESSION);
                _context5.next = 19;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5["catch"](8);
                this.setState(previousState);
                throw new Error(ObSessionServiceErrors.UNABLE_TO_DESTROY_SESSION);

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[8, 15]]);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "initSession",
    value: function () {
      var _initSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.fetch("".concat(this.obSessionServiceUrl, "?action=GoCasLogin&target=").concat(this.casUrl, "imAlive"), {
                  credentials: 'include',
                  signal: this.abortController.signal,
                  mode: 'no-cors'
                });

              case 3:
                _context6.next = 11;
                break;

              case 5:
                _context6.prev = 5;
                _context6.t0 = _context6["catch"](0);
                _context6.next = 9;
                return this.hasEstabilishedSession();

              case 9:
                if (_context6.sent) {
                  _context6.next = 11;
                  break;
                }

                throw _context6.t0;

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 5]]);
      }));

      function initSession() {
        return _initSession.apply(this, arguments);
      }

      return initSession;
    }()
  }, {
    key: "destroySession",
    value: function () {
      var _destroySession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return this.fetch("".concat(this.obSessionServiceUrl, "?action=DoLogout"), {
                  credentials: 'include',
                  redirect: this.shouldFollowLogout ? 'follow' : 'manual',
                  mode: 'cors'
                });

              case 3:
                _context7.next = 11;
                break;

              case 5:
                _context7.prev = 5;
                _context7.t0 = _context7["catch"](0);
                _context7.next = 9;
                return this.hasEstabilishedSession();

              case 9:
                if (!_context7.sent) {
                  _context7.next = 11;
                  break;
                }

                throw _context7.t0;

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 5]]);
      }));

      function destroySession() {
        return _destroySession.apply(this, arguments);
      }

      return destroySession;
    }()
  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(url, params) {
        var _yield$fetch, status;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return fetch(url, params);

              case 2:
                _yield$fetch = _context8.sent;
                status = _yield$fetch.status;

                if (!(status >= 400)) {
                  _context8.next = 6;
                  break;
                }

                throw new Error("Failed to fetch ".concat(url, ". Status: ").concat(status));

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }())
  }, {
    key: "hasValidSession",
    value: function () {
      var _hasValidSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(sessionId) {
        var shouldValidateSession;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                shouldValidateSession = !this.hasSessionSyncIdentifier() || sessionId != null && this.getSessionSyncIdentifier() === sessionId;

                if (!shouldValidateSession) {
                  _context9.next = 3;
                  break;
                }

                return _context9.abrupt("return", this.hasEstabilishedSession());

              case 3:
                return _context9.abrupt("return", false);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function hasValidSession(_x7) {
        return _hasValidSession.apply(this, arguments);
      }

      return hasValidSession;
    }()
    /**
     * Open bet session is managed by calling CAS & open bet in a chain of redirects.
     * Login: browser -> OB (start login & clear cookies) -> CAS (attach serviceTicket to OB login url)
     * -> OB (actual login, setting cookies) -> cas/imAlive (doesn't bring any value, validates only cas session, looks like workaround)
     * Logout: browser -> OB (remove cookies & session) -> we should not follow the rest redirects
     * during this chain CUST_SSL_COOKIE is being set/removed.
     * There are 2 known issues may happen during this chain.
     * - redirect to cas/imAlive or any other failed due to CORS issue
     * - redirects ends up in the infinite loop.
     * In both cases OB session will be still successfully created
     * We also don't want to call GoCasLogin action in case OB session already valid (browser refresh)
     * There is an OpenBet endpoint dedicated to check current cust_ssl_cookie
     * It will respond only with a HTTP status:
     * 200: Session is open and valid
     * 401: No session could be found or session has expired
     * 403: Session is not valid
     * 500: An error occurred when validating session
     */

  }, {
    key: "hasEstabilishedSession",
    value: function () {
      var _hasEstabilishedSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return fetch("".concat(this.obSessionServiceUrl, "?action=CheckCustSession"), {
                  credentials: 'include'
                });

              case 3:
                response = _context10.sent;
                return _context10.abrupt("return", response.ok);

              case 7:
                _context10.prev = 7;
                _context10.t0 = _context10["catch"](0);
                return _context10.abrupt("return", false);

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 7]]);
      }));

      function hasEstabilishedSession() {
        return _hasEstabilishedSession.apply(this, arguments);
      }

      return hasEstabilishedSession;
    }()
  }]);

  return ObSessionService;
}(ObSessionServiceInterface);

_defineProperty(ObSessionService, "SESSION_SYNC_IDENTIFIER", 'OB_SESS_SYNC_KEY');

export { ObSessionService as default };
//# sourceMappingURL=ObSessionService.js.map